const dataAccessMethods = require('../../dataAccessMethods');
const Blockly = require('blockly');
const ObjectId = require('bson-objectid');
const baseMdcBlockGroup = require('./_BaseMdcBlockGroup');
const { config } = require('@sstdev/lib_metadata-config');
//const logging = require('@sstdev/lib_logging');

const TOOLTIPS = {
    HiddenForValue: 'Hide if the data found in namespace/relation/propertyName of the form equals the specified value.',
    CustomizableVisibility: "Enable end user to configure access to this block's parent"
};

class AccessModifier extends baseMdcBlockGroup {
    /**
     * @param {{[key: string]: any}} code
     * @param {import('blockly').Block} blocklyBlock
     * @param {string} hNodeType
     */
    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        switch (hNodeType) {
            case 'ReadOnlyFor':
                return appendAccessModifier(blocklyBlock, 'readonlyfor', 'readOnlyFor');
            case 'ShowForViewPort':
                return appendAccessModifier(blocklyBlock, 'showforviewport', 'showForViewport');
            case 'HideOn':
                return appendAccessModifier(blocklyBlock, 'hideon', 'hideOn');
            case 'HiddenFor':
                return appendAccessModifier(blocklyBlock, 'hiddenfor', 'hiddenFor');
            case 'HiddenForValue':
                return appendAccessModifier(blocklyBlock, 'hiddenforvalue', 'hiddenForValue');
            case 'HiddenWhen':
                return appendAccessModifier(blocklyBlock, 'hidewhen', 'hideWhen');
            case 'DisableWhen':
                return appendAccessModifier(blocklyBlock, 'disablewhen', 'disableWhen');
            case 'AddForFeatureFlag':
                return appendAccessModifier(blocklyBlock, 'featureFlag', 'addForFeatureFlags');
            case 'RemoveForFeatureFlag':
                return appendAccessModifier(blocklyBlock, 'featureFlag', 'removeForFeatureFlags');
            case 'ShowForTenantSetting':
                return appendAccessModifier(blocklyBlock, 'tenantSetting', 'ShowForTenantSetting');
            case 'HideForTenantSetting':
                return appendAccessModifier(blocklyBlock, 'tenantSetting', 'HideForTenantSetting');
            case 'CustomizableVisibility':
                // blocklyFieldName ('accessTargetId') is not really used, but it IS the representative value.
                return appendAccessModifier(blocklyBlock, 'accessTargetId', 'customizableVisibility');
        }
    }

    addToBlocks() {
        const mdcBlock = this;
        this.buildControls.forEach(function (hNodeType) {
            // logging.debug(`[BLOCKLY] registering ${blockName(hNodeType, mdcBlock.hNodeTypeGroup)} block`);

            Blockly.Blocks[blockName(hNodeType, mdcBlock.hNodeTypeGroup)] = {
                init: function () {
                    const blocklyBlock = this;
                    this.data = this.data || 'bb' + new ObjectId().toString();

                    blocklyBlock.setColour(mdcBlock.color[0]);
                    blocklyBlock.setTooltip(TOOLTIPS[hNodeType] || mdcBlock.blockDescription);

                    const topInput = blocklyBlock.appendValueInput('securityModifier').setCheck('securityModifier');
                    mdcBlock.addToBlocksCustom(mdcBlock.color, blocklyBlock, hNodeType, mdcBlock, topInput);

                    blocklyBlock.setInputsInline(false);
                    blocklyBlock.setOutput(true, 'securityModifier');
                }
            };
        });
    }
    /**
     * @param {unknown} color
     * @param {import('blockly').Block} blocklyBlock
     * @param {string} hNodeType
     */
    addToBlocksCustom(color, blocklyBlock, hNodeType, mdcBlock, topInput) {
        switch (hNodeType) {
            case 'ReadOnlyFor':
                topInput
                    .appendField('Read Only For:')
                    .appendField(new Blockly.FieldDropdown(config.securityOptions), 'readonlyfor');
                break;
            case 'ShowForViewPort':
                topInput
                    .appendField('Show For Viewport:')
                    .appendField(new Blockly.FieldDropdown(config.viewPorts), 'showforviewport');

                break;
            case 'HideOn':
                topInput.appendField('Hide On:').appendField(new Blockly.FieldDropdown(config.platform), 'hideon');

                break;
            case 'HiddenFor':
                topInput
                    .appendField('Hidden For:')
                    .appendField(new Blockly.FieldDropdown(config.securityOptions), 'hiddenfor');
                break;
            case 'HiddenForValue': {
                const blockId = blocklyBlock.id;
                const workspace = blocklyBlock.workspace;
                let namespaceDropDown = new Blockly.FieldDropdown(dataAccessMethods.getNamespaces);
                namespaceDropDown.setTooltip('Optionally provide a namespace.');
                let relationDropdown = new Blockly.FieldDropdown(() =>
                    dataAccessMethods.getRelations(workspace, blockId)
                );
                relationDropdown.setTooltip('Optionally provide a relation.');

                topInput
                    .appendField('Hidden For Value:')
                    .appendField(namespaceDropDown, 'namespace')
                    .appendField(relationDropdown, 'relation')
                    .appendField(new Blockly.FieldTextInput('propertyName'), 'propertyName')
                    .appendField(new Blockly.FieldTextInput('value'), 'value');
                break;
            }
            case 'HiddenWhen':
                topInput.appendField('Hidden When:').appendField(
                    new Blockly.FieldDropdown([
                        ['Offline', 'OFFLINE'],
                        ['Online', 'ONLINE']
                    ]),
                    'hidewhen'
                );
                break;
            case 'DisableWhen':
                topInput
                    .appendField('Disable When:')
                    .appendField(
                        new Blockly.FieldDropdown([
                            ['Offline', 'OFFLINE'],
                            ['Online', 'ONLINE']
                        ]),
                        'disablewhen'
                    )
                    .appendField(new Blockly.FieldTextInput('message'), 'message');
                break;
            case 'AddForFeatureFlag':
                topInput
                    .appendField('Add For Feature Flag:')
                    .appendField(new Blockly.FieldTextInput('ffName'), 'featureFlag');
                break;
            case 'RemoveForFeatureFlag':
                topInput
                    .appendField('Remove For Feature Flag: ')
                    .appendField(new Blockly.FieldTextInput('ffName'), 'featureFlag');
                break;
            case 'ShowForTenantSetting':
                topInput
                    .appendField('Show For Tenant setting:')
                    .appendField(new Blockly.FieldTextInput('settingName'), 'tenantSetting');
                break;
            case 'HideForTenantSetting':
                topInput
                    .appendField('Hide For Tenant Setting: ')
                    .appendField(new Blockly.FieldTextInput('settingName'), 'tenantSetting');
                break;
            case 'CustomizableVisibility':
                topInput
                    .appendField('Customizable Visibility |  Title:')
                    .appendField(new Blockly.FieldTextInput('Allow user to ...'), 'title');
                //2nd line:
                blocklyBlock
                    .appendDummyInput()
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField('  Reference ID:')
                    .appendField(new Blockly.FieldTextInput(blocklyBlock.data), 'accessTargetId')
                    .appendField('  Readonly (Cannot Be Deselected):')
                    .appendField(new Blockly.FieldCheckbox(), 'readonly');
                break;
        }
    }
}

module.exports = AccessModifier;

function appendAccessModifier(block, blocklyFieldName, metaDataFieldName) {
    let limitingValue;
    if (metaDataFieldName == 'customizableVisibility') {
        let title = block.getFieldValue('title');
        let accessTargetId = block.getFieldValue('accessTargetId');
        let readonly = block.getFieldValue('readonly') == 'TRUE';
        limitingValue = { title, isTabAccess: isOnTab(block), accessTargetId, readonly };
    } else if (metaDataFieldName === 'hiddenForValue') {
        let foreignNamespace = block.getFieldValue('namespace');
        let foreignRelation = block.getFieldValue('relation');
        let propertyName = block.getFieldValue('propertyName');
        let value = block.getFieldValue('value');
        limitingValue = { foreignNamespace, foreignRelation, propertyName, value };
    } else if (metaDataFieldName === 'disableWhen') {
        let disableWhen = block.getFieldValue('disablewhen');
        let message = block.getFieldValue('message');
        limitingValue = { disableWhen, message };
    } else {
        limitingValue = block.getFieldValue(blocklyFieldName);
    }
    const childrenSecurityModifiers = Blockly.JavaScript.valueToCode(
        block,
        'securityModifier',
        Blockly.JavaScript.ORDER_NONE
    );
    let code = {};
    if (childrenSecurityModifiers) {
        code = JSON.parse(childrenSecurityModifiers);
    }
    if (code.hasOwnProperty(metaDataFieldName)) {
        code[metaDataFieldName].push(limitingValue);
    } else {
        code[metaDataFieldName] = [limitingValue];
    }
    return [JSON.stringify(code), Blockly.JavaScript.ORDER_NONE];
}

function blockName(hNodeType, hNodeTypeGroup) {
    return hNodeTypeGroup + '_' + hNodeType;
}

function isOnTab(block) {
    if (!block) return false;
    if (block.type.startsWith('accessModifier_')) {
        return isOnTab(block.getParent());
    }
    return block.type === 'layout_TabViewLayout';
}
